import { useQuery, useQueryClient } from "@tanstack/react-query"
import { useCallback } from "react"
import { ManufacturedDeviceGeneralInfo } from "../app/models/SupplierPortal"
import { digitalManagerApi } from "../services/api"

export function useManufacturedDevices() {
  const queryClient = useQueryClient()

  const { data: manufacturedDevicesList = [], isLoading: isLoadingManufacturedDevice } =
    useQuery({
      queryKey: ["manufacturedDevices"],
      queryFn: () =>
        digitalManagerApi
          .get<ManufacturedDeviceGeneralInfo[]>(`/litePanelPro/manufacturedDevices`)
          .then((r) => r.data),
    })

  const reloadManufacturedDevices = useCallback(
    () => queryClient.invalidateQueries({ queryKey: ["manufacturedDevices"] }),
    [queryClient]
  )

  return {
    manufacturedDevicesList,
    isLoadingManufacturedDevice,
    reloadManufacturedDevices,
  }
}
